// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1384":"94d757fa","2843":"b75b2759","3483":"b75b2759","4850":"ec156b9e","7614":"8604b459","8428":"94d757fa"}[chunkId] + ".chunk.css";
};